// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryProduct_wrapper__mF9H0","containerForVerySmall":"CategoryProduct_containerForVerySmall__XxuUW"};